import React from 'react';
import { TinyTitleBold } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import Congratulations from './BuyMethodBox/Congratulations';

interface Props {
  isWinner: boolean;
  reservationPriceReached: boolean;
  isSoldByBuyNow: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const AuctionResultTitle = styled(TinyTitleBold)`
  color: ${({ theme }) => theme.colors.text.dark};
  text-transform: uppercase;
  text-align: center;
`;

const AuctionResultSoldByBuyNowTitle = styled(AuctionResultTitle)`
  margin-top: 0.5rem;
`;

const AuctionResultExplanation = styled(TinyTitleBold)`
  color: ${({ theme }) => theme.colors.text.dark};
  margin-top: 0.5rem;
  text-align: center;
`;

const AuctionResultStatus = ({
  isWinner,
  reservationPriceReached,
  isSoldByBuyNow
}: Props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <AuctionResultTitle>{t('Bidding closed')}</AuctionResultTitle>
      {isSoldByBuyNow && (
        <AuctionResultSoldByBuyNowTitle>
          {t('The car was purchased at a fixed price')}
        </AuctionResultSoldByBuyNowTitle>
      )}

      {isWinner &&
        (reservationPriceReached ? (
          <Congratulations />
        ) : (
          <AuctionResultExplanation>
            {t('Highest bid, res price not reached')}
          </AuctionResultExplanation>
        ))}
    </Wrapper>
  );
};

export default AuctionResultStatus;
